import React, { useMemo } from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
    ConnectionProvider,
    WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { clusterApiUrl } from "@solana/web3.js";
import { ToastContainer } from 'react-toastify';


import "@solana/wallet-adapter-react-ui/styles.css";
import 'react-toastify/dist/ReactToastify.css';
import './app.scss';

import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import PortfolioPage from './pages/PortfolioPage';
import RewardPage from './pages/RewardPage';

function App() {
    const theme = createTheme({
        palette: { 
            mode: 'dark',
            background: {
                header: '#0B0E13',
                default: '#03050E',
                paper: '#0B0E14',
            },
        },
    });
    
    const endpoint = clusterApiUrl("devnet");
    const wallets = useMemo(() => [], []);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <ToastContainer
                position="top-right"
                autoClose={2500}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnHover
                style={{marginTop: 70}}
            />
            <ConnectionProvider endpoint={endpoint}>
                <WalletProvider wallets={wallets} autoConnect={true}>
                    <WalletModalProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route
                                    path="/"
                                    element={<HomePage />}
                                />
                                <Route
                                    path="/admin"
                                    element={<AdminPage />}
                                />
                                <Route
                                    path="/portfolio"
                                    element={<PortfolioPage />}
                                />
                                <Route
                                    path="/rewards2"
                                    element={<RewardPage />}
                                />
                            </Routes>
                        </BrowserRouter>
                    </WalletModalProvider>
                </WalletProvider>
            </ConnectionProvider>
        </ThemeProvider>
    );
}

export default App;
